// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonsPage-cls1__cc90103af884afa0e70f{/*!*/}.ButtonsPage-cls2___1438ec246245d21fafe{}.ButtonsPage-cls2___1438ec246245d21fafe.ButtonsPage-withBorder___70dd07120a93ac5d526{border-bottom:1px solid #dddde2;padding-bottom:16px;font-size:13px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ButtonsPage-cls1__cc90103af884afa0e70f",
	"cls2": "ButtonsPage-cls2___1438ec246245d21fafe ButtonsPage-cls1__cc90103af884afa0e70f",
	"withBorder": "ButtonsPage-withBorder___70dd07120a93ac5d526"
};
export default ___CSS_LOADER_EXPORT___;
